import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import {store} from './store/'
import router from './router/'
import firebase from './services/firebase.js'
import 'vue2-animate/dist/vue2-animate.min.css'

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

Vue.config.productionTip = false
const AlertCmp = () => import('./components/Alert.vue')
Vue.component('app-alert', AlertCmp)
/*
import PusherPlugin from './plugins/pusher'
Vue.use(PusherPlugin, {
  api_key: '725bec2aeb4a854bee21',
  options: {
      cluster: 'us2',
      encrypted: true
  }
})
*/
/*
import FeedsPlugin from './plugins/pusher-feeds'
Vue.use(FeedsPlugin, {
  instanceLocator: 'v1:us1:82cf52ae-b447-4ce5-9c97-20e5431e947c',
  key: 'bea1ab69-656b-40ca-8063-707bafc7ebcd:IMVE7ceEiegblWSpKIZ0ginDl6nAUNPLww9r/mlL13E='
})
*/
new Vue({
  store,
  router,
  render: h => h(App),
  created () {
    var self = this
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        firebase.auth().currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          self.$store.dispatch('autoSignIn', user)  
          self.$store.dispatch('setUserAccess', idTokenResult.claims)  
        })
        .catch((err) => {
          console.error(err)
        })
      }
    })
  }
}).$mount('#app')
